import React from 'react';
import MainLayout from '@/components/layout/MainLayout';
import { Separator } from '@/components/ui/separator';
import { Card, CardContent } from '@/components/ui/card';
import SEO from '@/components/common/SEO';

const About = () => {
  return (
    <MainLayout>
      <SEO
        title="About"
        description="Learn about mapleos and our mission to build a privacy-first digital canvas for chat, code, and creativity."
      />
      <div className="container max-w-4xl mx-auto py-8 px-4">
        <h1 className="text-3xl font-bold mb-2">About mapleos</h1>
        <p className="text-muted-foreground mb-8">Your digital canvas</p>

        <Separator className="my-6" />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mb-12">
          <div>
            <h2 className="text-2xl font-semibold mb-4">Our Mission</h2>
            <p className="text-muted-foreground mb-4">
              At mapleos, we're building an AI-first workspace that stays fast, flexible, and respectful of your data.
              We believe AI should enhance human capabilities and improve quality of life across all sectors of society.
            </p>
            <p className="text-muted-foreground">
              Built in Canada, we work tirelessly to ship cutting-edge features that address real-world challenges
              while prioritizing privacy, security, and transparency.
            </p>
          </div>

          <div className="bg-muted rounded-lg p-6">
            <h2 className="text-2xl font-semibold mb-4">Our Values</h2>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <div className="h-6 w-6 rounded-full bg-primary/15 text-primary flex items-center justify-center flex-shrink-0 mt-0.5">1</div>
                <div>
                  <span className="font-medium">Innovation</span> — Pushing boundaries and exploring new frontiers in AI research
                </div>
              </li>
              <li className="flex items-start gap-2">
                <div className="h-6 w-6 rounded-full bg-primary/15 text-primary flex items-center justify-center flex-shrink-0 mt-0.5">2</div>
                <div>
                  <span className="font-medium">Accessibility</span> — Making advanced tools available to everyone
                </div>
              </li>
              <li className="flex items-start gap-2">
                <div className="h-6 w-6 rounded-full bg-primary/15 text-primary flex items-center justify-center flex-shrink-0 mt-0.5">3</div>
                <div>
                  <span className="font-medium">Ethics</span> — Building systems that align with human values and societal wellbeing
                </div>
              </li>
              <li className="flex items-start gap-2">
                <div className="h-6 w-6 rounded-full bg-primary/15 text-primary flex items-center justify-center flex-shrink-0 mt-0.5">4</div>
                <div>
                  <span className="font-medium">Privacy</span> — Respecting and protecting user data with rigorous security measures
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="bg-muted rounded-lg p-6 mb-8">
          <h2 className="text-2xl font-semibold mb-4">Our Approach</h2>
          <p className="mb-4">
            At mapleos, we believe artificial intelligence should be developed with a human-centered approach.
            Our technologies are designed to augment human capabilities, not replace them. We prioritize:
          </p>
          <ul className="space-y-2 list-disc pl-5 mb-4">
            <li>Transparent systems that can be understood and trusted</li>
            <li>Privacy-preserving techniques that protect user data</li>
            <li>Inclusive design principles that ensure our products work for everyone</li>
            <li>Continuous learning and improvement based on user feedback</li>
          </ul>
          <p>
            Through this approach, we're creating AI that's not just powerful, but responsible and aligned with the needs of users from all walks of life.
          </p>
        </div>
      </div>
    </MainLayout>
  );
};

export default About;